/* eslint-disable @typescript-eslint/no-unused-vars */
import { Draft, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGroupPermissionData, IOptionsPermissionData, IPermissionManagementState } from "types/models/permission-management";
import { RootState } from "types/reducer";

const initialState: IPermissionManagementState = {
  group: [],
  options: []
};

const PermissionManagementSlice = createSlice({
  name: "permission_management",
  initialState,
  reducers: {
    clearDataPermissionPage(
      state: Draft<IPermissionManagementState>
    ){
      state.group = [];
      state.options = [];
    },
    fetchGroupPermissions(
      state: Draft<IPermissionManagementState>
    ){

    },
    fetchGroupPermissionsSuccess(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IGroupPermissionData[]>
    ){
      state.group = action.payload;
    },
    fetchOptionPermissions(
      state: Draft<IPermissionManagementState>
    ){

    },
    fetchOptionPermissionsSuccess(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IOptionsPermissionData[]>
    ){
      state.options = action.payload;
    },
    createNewGroupPermission(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IGroupPermissionData>
    ){

    },
    createNewGroupPermissionSuccess(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IGroupPermissionData[]>
    ){
      state.group = action.payload;
    },
    editGroupPermission(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<any>
    ){

    },
    editGroupPermissionSuccess(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IGroupPermissionData[]>
    ){
      state.group = action.payload;
    },
    deleteGroupPermission(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<any>
    ){

    },
    deleteGroupPermissionSuccess(
      state: Draft<IPermissionManagementState>,
      action: PayloadAction<IGroupPermissionData[]>
    ){
      state.group = action.payload;
    }
  },
});

// Actions
export const fetchGroupPermissions = PermissionManagementSlice.actions.fetchGroupPermissions;
export const fetchGroupPermissionsSuccess = PermissionManagementSlice.actions.fetchGroupPermissionsSuccess;

export const fetchOptionPermissions = PermissionManagementSlice.actions.fetchOptionPermissions;
export const fetchOptionPermissionsSuccess = PermissionManagementSlice.actions.fetchOptionPermissionsSuccess;

export const createNewGroupPermission = PermissionManagementSlice.actions.createNewGroupPermission;
export const createNewGroupPermissionSuccess = PermissionManagementSlice.actions.createNewGroupPermissionSuccess;

export const editGroupPermission = PermissionManagementSlice.actions.editGroupPermission;
export const editGroupPermissionSuccess = PermissionManagementSlice.actions.editGroupPermissionSuccess;

export const deleteGroupPermission = PermissionManagementSlice.actions.deleteGroupPermission;
export const deleteGroupPermissionSuccess = PermissionManagementSlice.actions.deleteGroupPermissionSuccess;

export const clearDataPermissionPage = PermissionManagementSlice.actions.clearDataPermissionPage;

// Selectors
export const getGroupPermissions = (state: RootState) => state.permission_management.group;
export const getOptionPermissions = (state: RootState) => state.permission_management.options;

// Reducer
const PermissionManagementReducer = PermissionManagementSlice.reducer;
export default PermissionManagementReducer;
